export default __webpack_public_path__ + "static/media/1stScreenBG.699f9202.png";